import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _isEmpty from "lodash/isEmpty";
var _excluded = ["pros", "cons", "marketplaceEntity", "showBestOfAwards", "bottomLine", "hidePrequalCta"];
import "core-js/modules/es6.array.map.js";
import { getBottomLine, getConsBullets, getDisplayName as getName, getProductType, getProsBullets, getSlug, getThisYearBestOfAwards } from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { getImageData, DEFAULT_DRIVER_GROUP } from '../lib/utils';
import mapPropsAutoLoans from './auto-loans';
import mapPropsBanking from './banking';
import mapPropsEducationLoans from './education-loans';
import mapPropsInsurance from './insurance';
import mapPropsInvesting from './investing';
import mapPropsMortgages from './mortgages';
import mapPropsPersonalLoans from './personal-loans';
import mapPropsSmbLoans from './small-medium-business-loans';
import mapPropsCreditCards, { DRIVER_GROUPS_CREDIT_CARDS } from './credit-cards';
import { PREHEADER_TYPE } from '../lib/constants';
export default (function (props) {
  var pros = props.pros,
      cons = props.cons,
      marketplaceEntity = props.marketplaceEntity,
      showBestOfAwards = props.showBestOfAwards,
      bottomLine = props.bottomLine,
      hidePrequalCta = props.hidePrequalCta,
      explicitOverrides = _objectWithoutProperties(props, _excluded);

  var mappedProps = {};

  switch (getProductType(marketplaceEntity)) {
    case PRODUCT_TYPES.AUTO_LOANS:
      mappedProps = mapPropsAutoLoans(props);
      break;

    case PRODUCT_TYPES.BANKING:
      mappedProps = mapPropsBanking(props);
      break;

    case PRODUCT_TYPES.CREDIT_CARDS:
      mappedProps = mapPropsCreditCards(props);
      break;

    case PRODUCT_TYPES.EDUCATION_LOANS:
      mappedProps = mapPropsEducationLoans(props);
      break;

    case PRODUCT_TYPES.INSURANCE:
      mappedProps = mapPropsInsurance(props);
      break;

    case PRODUCT_TYPES.INVESTING:
      mappedProps = mapPropsInvesting(props);
      break;

    case PRODUCT_TYPES.MORTGAGES:
      mappedProps = mapPropsMortgages(props);
      break;

    case PRODUCT_TYPES.PERSONAL_LOANS:
      mappedProps = mapPropsPersonalLoans(props);
      break;

    case PRODUCT_TYPES.SMB_LOANS:
      mappedProps = mapPropsSmbLoans(props);
      break;

    default:
      mappedProps = {};
      break;
  }

  if (showBestOfAwards) {
    var thisYearAwards = getThisYearBestOfAwards(marketplaceEntity);

    if (thisYearAwards !== null && thisYearAwards !== void 0 && thisYearAwards.length) {
      var thisYearAwardsText = thisYearAwards.map(function (value) {
        return value.category;
      }).join(', ');
      mappedProps.hasPreheader = true;
      mappedProps.preheaderHoverText = thisYearAwardsText;
      mappedProps.preheaderText = thisYearAwardsText;
      mappedProps.preheaderType = PREHEADER_TYPE.BADGE;
    }
  }

  return _objectSpread(_objectSpread({
    bottomLine: bottomLine || getBottomLine(marketplaceEntity),
    cons: !_isEmpty(cons) ? cons : getConsBullets(marketplaceEntity),
    heading: getName(marketplaceEntity),
    imageData: getImageData(marketplaceEntity),
    marketplaceEntity: marketplaceEntity,
    marketplaceEntitySlug: getSlug(marketplaceEntity),
    pros: !_isEmpty(pros) ? pros : getProsBullets(marketplaceEntity)
  }, mappedProps), explicitOverrides);
});
/**
 * @deprecated
 */

export var DRIVER_GROUPS = _objectSpread(_defineProperty({}, DEFAULT_DRIVER_GROUP, DEFAULT_DRIVER_GROUP), DRIVER_GROUPS_CREDIT_CARDS);